import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ui-search-input',
  templateUrl: './ui-search-input.component.html',
  styleUrls: ['./ui-search-input.component.scss']
})
export class UiSearchInputComponent {
  @Input() placeholder = 'Search...';
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();
  @Output() enter = new EventEmitter<string>();

  onInput(event: Event): void {
    const val = (event.target as HTMLInputElement).value;
    this.value = val;
    this.valueChange.emit(val);
  }

  onEnter(): void {
    this.enter.emit(this.value);
  }
}
